import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import { ApplicationState } from '~/store';
import { selectEmail } from '~/store/ducks/appControllers/actions';
import { AuthState } from '~/store/ducks/auth/types';
import { StyledButton, Wrapper, WrapperTest } from './styles';

const useStyles = makeStyles({
  root: {
    fontSize: 36,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  icon: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
});

// Inspired by blueprintjs
function StyledRadio(props: RadioProps) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

interface IProps {
  nexAuth(): void;
  list: string[];
  children: React.ReactNode;
}

interface StateProps {
  language: any;
  auth: AuthState;
}

interface DispatchProps {
  selectEmail(emailSelected: number): void;
}

type Props = StateProps & DispatchProps & IProps;

class RequestPassword extends Component<Props> {
  componentDidMount() {
    document.title = 'Solicitar Senha | Portal LGPD';
  }

  state: { hasEmail: boolean } = { hasEmail: false };

  renderMail = () => {
    const { list: emailList, language, selectEmail } = this.props;

    const list = [...emailList];

    let render = false;

    if (list) {
      for (let index = 0; index < list.length; index++) {
        if (list[index].includes('@')) {
          render = true;
        }
      }
    }

    if (render) {
      return (
        <FormControl component="fieldset">
          <RadioGroup aria-label="list-email" name="select-email">
            {list.length &&
              list.map((el, i) => {
                if (
                  el !== null &&
                  el !== ' ' &&
                  el !== '' &&
                  el !== undefined &&
                  el !== 'null'
                ) {
                  return (
                    <FormControlLabel
                      key={i}
                      classes={{ label: 'label-email' }}
                      value={el + i}
                      control={<StyledRadio />}
                      label={el}
                      onChange={() => {
                        selectEmail(i);
                      }}
                    />
                  );
                }

                return <></>;
              })}
          </RadioGroup>
        </FormControl>
      );
    } else {
      return (
        <p className="warning">{language?.login?.voceNãoTemEmailCadastrado}</p>
      );
    }
  };

  //@ts-ignore
  renderButtonAndCapt = (children, nexAuth) => {
    const { list: emailList, language } = this.props;

    const list = [...emailList];

    let render = false;

    if (list) {
      for (let index = 0; index < list.length; index++) {
        if (list[index].includes('@')) {
          render = true;
        }
      }
    }

    if (render) {
      return (
        <>
          <div className="ReCAPTCHA">{children}</div>

          <div className="StyledButton-align">
            <StyledButton className="button-continue" onClick={nexAuth}>
              {!!language?.login?.continuar && language?.login?.continuar}
            </StyledButton>
          </div>
        </>
      );
    } else {
      return <p />;
    }
  };

  setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  render() {
    const { nexAuth, children, language, auth } = this.props;

    return (
      <WrapperTest>
        <Wrapper>
          <div className="content-small">
            <div className="vrio-corp">
              <span>Vrio Corp</span>
            </div>

            <div className="welcome">
              <h2>{language?.login?.bemVindo}</h2>
              <h1>{language?.login?.LGPDSystem}</h1>
            </div>
          </div>
          <div className="container-form">
            <form action="">
              <div className="header">
                {auth.company?.country_company_id ? (
                  <img
                    src={this.setLogo(auth.company.country_company_id)}
                    alt={`logo ${auth.company?.company?.company_name?.toUpperCase()}`}
                  />
                ) : (
                  ''
                )}

                <h1>{language?.login?.solicitarSenha}</h1>
                <h4>{language?.login?.escolhaUmEmailParaReceberASenha}</h4>
              </div>

              {this.renderMail()}

              {this.renderButtonAndCapt(children, nexAuth)}
            </form>

            <div className="nav-options">
              <p>
                <a href={`/${auth?.company?.path_alias_nm}`}>
                  {language?.login?.facaLoginEmUmaContaDiferente}
                </a>
              </p>
              <p>
                <a href={`/${auth?.company?.path_alias_nm}/contactdpo`}>
                  {language?.login?.solicitarAjudaAoDPO}
                </a>
              </p>
            </div>

            <p className="footer">
              {language?.login?.politicaGoogle.parte_1}{' '}
              <a
                href="https://policies.google.com/privacy?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.login?.politicaGoogle.parte_2}
              </a>{' '}
              {language?.login?.politicaGoogle.parte_3}{' '}
              <a
                href="https://policies.google.com/terms?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.login?.politicaGoogle.parte_4}
              </a>{' '}
              {language?.login?.politicaGoogle.parte_5}
            </p>
          </div>
        </Wrapper>
      </WrapperTest>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  language: state.language.data,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({ selectEmail }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestPassword);
